import { Link } from 'react-router-dom';
import { useBasePath } from '../../lib/config/nav-helpers';
import { INTEGRATIONS_PATH, NOT_CONNECTED, type Need } from '../../lib/coverage';

/** The honest empty state for a source Waypoint cannot see (connected and synced): see lib/coverage.ts. */
export function NotConnected({ need }: { need: Need }) {
  const basePath = useBasePath();
  const { action, cant } = NOT_CONNECTED[need];
  return (
    <p className="text-2xs text-ink-dim">
      {cant}.{' '}
      <Link to={`${basePath}${INTEGRATIONS_PATH}`} className="font-semibold text-primary hover:underline">{action} →</Link>
    </p>
  );
}
